import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';

declare var $:any;

@Injectable()
export class ImgBookService {
    
    imageObject: any;

    constructor(private http: HttpClient, 
        private apiGatewayHelperService: ApiGatewayHelperService
    ) { }

    /* options = {
        "containerId" : "imgbook",
        "studentBook" : "that.studentBook",
        "currentPageLabel" : "asdasd",
        "extUserId" : "asdasd",
        "onBookDataLoad" : "callbackFunction1",
        "onPageLoad" : "callbackFunction2"
    }*/
    // get imgbook instance
    public getImgBook(options) {
        
        if(!this.imageObject) {
            this.imageObject = $('#' + options.containerId).imgBookReader(options.studentBook.meta.code, {
                bookAssetServer : options.studentBook.meta.paths["public-assets"] + "/",
                bookBaseFolder : '',
                pageLayout : options.appState.layout,
                minZoomLimit : 10,
                initialPageNo : options.appState.page,
                enableMouseDragScroll: true,
                user_unique_id: options.extUserId,
                enableAnnotations: false,
                allowAnnotationSharing: false,
                disablePagePreloading: options.disablePagePreloading,
                contentHeight: function() { 

                /**
                 *  NEMO-5771 : [eReader] Extra gray space is visible at the top of the eBook page when viewed on mobile devices.
                 *  NEMO-6334 : ebook not covered by toolbar
                 *  Subtracting 64px (height of toolbar in mobile) from container height to calculate content height.
                 * */
                    return window.innerHeight - 64 - ($(".cookies-banner").outerHeight()?$(".cookies-banner").outerHeight():0);
                },
                onBookDataLoad : options.onBookDataLoad.bind(options.studentBookInstance),
                swipeNextPage: options.swipeNextPage.bind(options.studentBookInstance),
                swipePrevPage: options.swipePrevPage.bind(options.studentBookInstance),
                onPageLoad: options.onPageLoad.bind(options.studentBookInstance),
                onPageLoadCalledAgain: options.onPageLoadCalledAgain.bind(options.studentBookInstance),
                onOverlaySelect: options.onOverlaySelect.bind(options.studentBookInstance),
                onOverlayDblClick: options.onOverlayDblClick.bind(options.studentBookInstance),
                onOverlayJSONLoad : options.onOverlayJSONLoad.bind(options.studentBookInstance),
                onPinchEndGesture: options.onPinchEndGesture.bind(options.studentBookInstance),
                onPinchOutGesture : options.onPinchOutGesture.bind(options.studentBookInstance),
                onPinchInGesture : options.onPinchInGesture.bind(options.studentBookInstance),
                onPageLayoutChange : options.onPageLayoutChange.bind(options.studentBookInstance),
                onPageLoadErrorCallback : options.onPageLoadErrorCallback.bind(options.studentBookInstance),
                enableOverlays: true,
                isScrollbarHidden: true,
                isCoverSmall: false, // to make the cover fit to screen by default (no special handling for cover which actually reduces the cover size so that top and bottom margins are visible)
                useWebFonts: false,
                paths : {
                    "imageRenderer" : {
                        "pageSmImgFolder": "images/sm/",
                        "pageMedImgFolder": "images/med/",
                        "pageLrgImgFolder": "images/lrg/",
                        "pageThumbImgFolder": "images/thumbnail/",
                        "pagexlLrgImgFolder": "images/xlrg/",
                        "pageSmImgTextFolder": "images/smtext/",        
                        "pageMedImgTextFolder": "images/medtext/",        
                        "pageLrgImgTextFolder": "images/lrgtext/",
                        "pageThumbImgTextFolder": "images/thumbnailtext/",
                        "pagexlLrgImgTextFolder": "images/xlrgtext/",
                        "pageTextDataFolder": "images/json/"
                    },
                    "bookDataPath": "imgbook-meta/book.json",
                    "hotspotDataFolder": "imgbook-meta"
                },
                disableAutoLayoutSwitch: false,
                annotationObject: {
                    productCode: options.studentBook.meta.title,
                    eventContext : {
                        _readerEvt_annotationDeleted: function() {
                            console.log("annotationDeleted");
                        },
                        _readerEvt_annotationCreated: function() {
                            console.log("annotationCreated");
                        },
                        _readerEvt_annotationUpdated: function() {
                            console.log("annotationUpdated");
                        }
                    }    
                }
                ,
                bookDataJSON: options.studentBook.meta["book-info"],
                bookOverlayJSON: options.studentBook.overlays,
                preLoadPages: options.pagesToPreload
            });
        }
        return this.imageObject;
    }

    public removeImgBookInstance() {
        this.imageObject = undefined;
    }

    public getCurrentPageLayout() {
        if(this.imageObject) {
            let layout;
            let pages = this.imageObject.getPageNumber();
            if(pages.length == 1) {
               layout = PAGE_LAYOUT.SINGLE;
            } else {
                layout = PAGE_LAYOUT.DOUBLE;
            }
            return layout;
        }
    }

    public changeImgbookLayout(layout) {
        if(this.imageObject) {
            this.imageObject.changeLayout(layout);
        }
    }
}

enum PAGE_LAYOUT {
    SINGLE = "single",
    DOUBLE = "double"
}
   